<div class="calendar-event-dialog">
  <h2 mat-dialog-title>
    <mat-icon class="title-icon">{{ isEdit ? 'edit_calendar' : 'add_circle' }}</mat-icon>
    {{ isEdit ? 'Esemény szerkesztése' : 'Új esemény' }}
  </h2>

  <div mat-dialog-content>
    <!-- Esemény típus -->
    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Típus</mat-label>
      <mat-select [(ngModel)]="eventType">
        @for (type of eventTypes; track type.value) {
          <mat-option [value]="type.value">{{ type.label }}</mat-option>
        }
      </mat-select>
    </mat-form-field>

    <!-- Cím / Cég - Időpontnál autocomplete -->
    @if (eventType === 'appointment') {
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Cég - Tisztségviselők</mat-label>
        <input matInput
               [(ngModel)]="title"
               (ngModelChange)="onTitleInput($event)"
               (focus)="loadDefaultCompanies()"
               [matAutocomplete]="companyAuto"
               placeholder="Pl. ABC Kft. - Kovács János"
               maxlength="200">
        <mat-autocomplete #companyAuto="matAutocomplete"
                          (optionSelected)="onCompanySelected($event.option.value)">
          @for (company of agreedCompanies; track company.id) {
            <mat-option [value]="company">
              <span class="company-option">
                <strong>{{ company.companyname }}</strong>
                @if (company.officials) {
                  <span class="officials-text"> - {{ company.officials }}</span>
                }
              </span>
            </mat-option>
          }
        </mat-autocomplete>
      </mat-form-field>
    } @else {
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Cím</mat-label>
        <input matInput [(ngModel)]="title" placeholder="Esemény címe" maxlength="200">
      </mat-form-field>
    }

    <!-- Egész napos + Naptár választó -->
    <div class="allday-calendar-row">
      <mat-checkbox [(ngModel)]="allDay" class="all-day-check">
        Egész napos esemény
      </mat-checkbox>

      @if (eventType === 'appointment' && kumVisibleUsers.length > 0) {
        <mat-form-field appearance="outline" class="calendar-select">
          <mat-label>Naptár</mat-label>
          <mat-select [(ngModel)]="targetUserId">
            <mat-option [value]="-1">Saját naptár</mat-option>
            @for (user of kumVisibleUsers; track user.user_id) {
              <mat-option [value]="user.user_id">{{ user.fullname }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      }
    </div>

    <!-- Kezdő dátum + idő -->
    <div class="datetime-row">
      <mat-form-field appearance="outline" class="date-field">
        <mat-label>Kezdés</mat-label>
        <input matInput [matDatepicker]="startPicker" [ngModel]="startDate" (ngModelChange)="onStartDateChange($event)">
        <mat-datepicker-toggle matIconSuffix [for]="startPicker"></mat-datepicker-toggle>
        <mat-datepicker #startPicker></mat-datepicker>
      </mat-form-field>

      @if (!allDay) {
        <mat-form-field appearance="outline" class="time-field"
          [class.time-field-invalid]="startTimeInput.touched && startTimeInput.invalid"
          [class.time-outside-hours]="isTimeOutsideWorkHours(startTime)">
          <mat-label>Idő</mat-label>
          <input matInput
                 name="startTime"
                 #startTimeInput="ngModel"
                 [ngModel]="startTime"
                 (ngModelChange)="onStartTimeChange($event)"
                 [matAutocomplete]="startTimeAuto"
                 pattern="^([01]?[0-9]|2[0-3]):[0-5][0-9]$"
                 placeholder="ÓÓ:PP">
          <mat-autocomplete #startTimeAuto="matAutocomplete">
            @for (t of timeSlots; track t) {
              <mat-option [value]="t">{{ t }}</mat-option>
            }
          </mat-autocomplete>
          @if (isTimeOutsideWorkHours(startTime)) {
            <mat-hint class="outside-hours-hint">Az időpont munkaidőn kívül esik</mat-hint>
          }
        </mat-form-field>
      }
    </div>

    <!-- Záró dátum + idő -->
    <div class="datetime-row">
      <mat-form-field appearance="outline" class="date-field">
        <mat-label>Befejezés</mat-label>
        <input matInput [matDatepicker]="endPicker" [(ngModel)]="endDate">
        <mat-datepicker-toggle matIconSuffix [for]="endPicker"></mat-datepicker-toggle>
        <mat-datepicker #endPicker></mat-datepicker>
      </mat-form-field>

      @if (!allDay) {
        <mat-form-field appearance="outline" class="time-field"
          [class.time-field-invalid]="endTimeInput.touched && endTimeInput.invalid"
          [class.time-outside-hours]="isTimeOutsideWorkHours(endTime)">
          <mat-label>Idő</mat-label>
          <input matInput
                 name="endTime"
                 #endTimeInput="ngModel"
                 [(ngModel)]="endTime"
                 [matAutocomplete]="endTimeAuto"
                 pattern="^([01]?[0-9]|2[0-3]):[0-5][0-9]$"
                 placeholder="ÓÓ:PP">
          <mat-autocomplete #endTimeAuto="matAutocomplete">
            @for (t of timeSlots; track t) {
              <mat-option [value]="t">{{ t }}</mat-option>
            }
          </mat-autocomplete>
          @if (isTimeOutsideWorkHours(endTime)) {
            <mat-hint class="outside-hours-hint">Az időpont munkaidőn kívül esik</mat-hint>
          }
        </mat-form-field>
      }
    </div>

    <!-- Helyszín - csak Egyéb típusnál -->
    @if (eventType === 'other') {
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Helyszín</mat-label>
        <input matInput [(ngModel)]="location" placeholder="Pl. Iroda, Online">
        <mat-icon matPrefix>location_on</mat-icon>
      </mat-form-field>
    }

    <!-- Leírás -->
    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Leírás</mat-label>
      <textarea matInput [(ngModel)]="description"
                [rows]="eventType === 'appointment' && description ? 10 : 3"
                placeholder="Megjegyzések..."></textarea>
    </mat-form-field>
  </div>

  <div mat-dialog-actions align="end">
    <button mat-button (click)="onCancel()">Mégse</button>
    <button mat-flat-button color="primary" (click)="onSave()" [disabled]="!isFormValid">
      <mat-icon>{{ isEdit ? 'save' : 'add' }}</mat-icon>
      {{ isEdit ? 'Mentés' : 'Létrehozás' }}
    </button>
  </div>
</div>
